import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { MatCheckboxChange } from "@angular/material/checkbox";
import { AppAnimations } from "src/app/_shared/animations";
import { PermissionManagerService } from "src/app/_shared/services/permission/permissions.service";
import { VisibleState } from "src/app/app.data";

@Component({
  animations: [AppAnimations],
  selector: "app-usage-based-rules",
  templateUrl: "./usage-based-rules.component.html",
  styleUrls: ["./usage-based-rules.component.scss"],
})
export class UsageBasedRulesComponent implements OnInit {
  form: FormGroup;
  @Input() _data: any;
  @Input() _visibleState = VisibleState;
  @Output() _emitChangeUsageBasedRules: EventEmitter<any> = new EventEmitter<any>();

  constructor(private _fb: FormBuilder,private permissionS: PermissionManagerService
    ) {}

  ngOnInit(): void {
    const  { usageType } = this._data?.ratePlanCharge;
    this.setUpForm(usageType);

    this.form.valueChanges.subscribe((res)=>{
      this._emitChangeUsageBasedRules.emit(res);
    })

    if(!this._data.isProduct && this._data.isEdit){
      this.form.disable()
    }
  }

  setUpForm(usageType?: any) {
    this.form = this._fb.group({
      usageBased: [usageType ? true: false],
      usageType: [usageType]
    });
    
    if(usageType){
      this._emitChangeUsageBasedRules.emit(this.form.value);
    }

    this.permissionS.checkInput('feature_usagebased|enabled|SCOPE_SET_VALUE', this.form, 'usageBased');

  }

  onChange(event: MatCheckboxChange): void {
    const usageTypeCtrl = this.form.get('usageType');
    if(event.checked){
      usageTypeCtrl.setValue('aggregated');
    } else {
      usageTypeCtrl.reset();
    }
  }
}
